import axios from 'axios'
import head from 'lodash/head'
import { load_one, load_many, _get_counts } from '../action-helpers.js'
import { omit } from 'lodash'
import http from '@/http'

// noinspection JSUnusedGlobalSymbols
export default {

    /**
     * Lädt eine Seite Adressen vom Server (server-seitige Paginierung).
     */
    async loadPage({ commit }, { page = 0, size = 20, filter, company } = {}) {
        const params = { page, size }
        if (filter === 'SHIPPING')       params.isShippingAddress = true
        if (filter === 'BILLING')        params.isBillingAddress = true
        if (filter === 'CORRESPONDENCE') params.isCorrespondenceAddress = true
        if (company)                     params.company = company
        const response = await http({ method: 'GET', url: 'addresses', params })
        const addresses = response.data.content
        commit('SET_MANY', { content: addresses })
        commit('SET_COUNTS', { content: _get_counts(response.headers) })
        return { addresses, total: response.data.totalElements }
    },

    create({ dispatch }, { model }) {
        return axios.post('/api/v1/addresses', model).then(response => {
            return Promise.all([
                dispatch('loadOne', { id: response.data.id }),
                dispatch('loadAll', { force: true })
            ]).then(head)
        })
    },

    loadAll: load_many('addresses', { setCounts: true }),

    // TODO
    loadAllByCompanyIdAndIsBillingAddress: load_many('addresses', { params: { company: ':companyId' } }),

    // TODO
    loadAllByCompanyIdAndIsShippingAddress: load_many('addresses', { params: { company: ':companyId' } }),
    loadAllByCompanyId: load_many('addresses', { params: { company: ':companyId' } }),
    loadAllByJobId: load_many('jobs/:jobId/addresses'),
    loadAllByBelongsToZmuekCompany: load_many('addresses', { params: { company: '2' } }),
    loadOne: load_one('addresses/:id'),

    loadAllByIds({ dispatch }, { ids, force }) {
        return Promise.all(
            ids.map(id => dispatch('loadOne', { id, force }) )
        )
    },

    update({ dispatch }, { model }) {
        const payload = {
            ...omit(model, ['country', 'state', 'companies']),
            countryId: model.country,
            stateId: model.state,
            companyLinks: model.companies
        }

        return axios.put(`/api/v1/addresses/${model.id}`, payload).then(() => {
            return Promise.all([
                dispatch('loadOne', { id: model.id, force: true }),
                dispatch('loadAll', { force: true })
            ]).then(head)
        })
    },

}
